import { formatNumberForTable } from "@/Utils/formatFunctions";

import type React from "react";

import { twMerge } from "tailwind-merge";

import type { ReportingTableHeader } from "../../types";
import {
  CHECKBOX_COLUMN_ID,
  NAME_COLUMN_ID,
  PERIOD_COLUMN_ID,
  RATE_COLUMN_ID,
  TOTAL_COLUMN_ID,
} from "../dataFunctions/headers";

export type StickyPosition = { left?: number; right?: number };

export const ROW_BACKGROUND = {
  selected: "#FBFBE9",
  hovered: "#F7F2F2",
  default: "#fff",
};

export const formatNumber = (value: number) =>
  formatNumberForTable(value, {
    numDecimals: 2,
    fixedDecimals: true,
    maxLength: Infinity,
  });

export const formatRate = (rate: number) =>
  formatNumberForTable(rate, { suffix: " %" });

export const getRateColorClass = (rate: number) => {
  if (rate >= 70) return "text-carrot-green";
  if (rate >= 40) return "text-[#1D1C1C]";
  return "text-tomato";
};

// Must match the padding in the header cells' columnStyle.
export const getCellPaddingClass = (id: string, isIndividualTab: boolean) => {
  switch (id) {
    case CHECKBOX_COLUMN_ID:
      return "pr-0 pl-[18px]";
    case NAME_COLUMN_ID:
      return "pr-[12px] pl-[4px]";
    case PERIOD_COLUMN_ID:
      return "pr-[16px] pl-[22px]";
    case RATE_COLUMN_ID:
      return "px-[16px]";
    case TOTAL_COLUMN_ID:
      return twMerge("pl-[14px]", isIndividualTab ? "pr-[18px]" : "pr-[22px]");
    default:
      return "px-[14px]";
  }
};

export const getStickyPositions = (headers: ReportingTableHeader[]) => {
  const positions: Record<string, StickyPosition> = {};

  let left = 0;
  let index = 0;
  for (; index < headers.length && headers[index].isFixedColumn; index++) {
    positions[headers[index].id] = { left };
    left += headers[index].width;
  }

  let right = 0;
  for (
    let i = headers.length - 1;
    i >= index && headers[i].isFixedColumn;
    i--
  ) {
    positions[headers[i].id] = { right };
    right += headers[i].width;
  }

  return positions;
};

export const getStickyStyle = (
  position?: StickyPosition,
  style?: React.CSSProperties,
): React.CSSProperties | undefined =>
  position ? { position: "sticky", ...position, ...style } : style;
